
import { mapGetters, mapActions } from "vuex"
import { simpleUrl } from "@/utils/_"

export default {
  // validate ({ store }) {
  //   return store.getters["user/isAdmin"]
  // },

  async asyncData ({ route, redirect, app, $api }) {
    const goToExhibitors = () => redirect(app.localePath("/exhibitors"))

    const exhibitorId = route.params.id
    if (!exhibitorId) return goToExhibitors()

    const [res, err] = await $api.exhibition.getApp(exhibitorId)
    if (err) return goToExhibitors()
    const exhibitor = res

    return { exhibitor }
  },

  data: () => ({
    exhibitor: null,
    bevel: 8,
  }),

  head () {
    return { title: this.title }
  },

  computed: {
    ...mapGetters("user", ["user", "favoriteExhibitors"]),

    isMe () {
      return this.exhibitor.author.id === this.user?.id
    },

    isFavorite () {
      return Boolean(this.favoriteExhibitors
        .find(fe => fe.id === this.exhibitor.id))
    },

    title () {
      const { exhibitor } = this
      if (!exhibitor) return ""
      const { companyCountry, projectName, companyName } = exhibitor
      const name = companyCountry === "RU"
        ? this.$fmt.localize(projectName)
        : projectName.en
      return name || companyName
    },

    params () {
      const { exhibitor, getProfitValue } = this
      const { year } = this.$config
      const prevYear = year - 1

      return [
        {
          key: { ru: "Стадия проекта", en: "Project stage description" },
          value: exhibitor.projectStage,
        },
        {
          key: { ru: "Требуемые инвестиции", en: "Funds needed" },
          value: `${exhibitor.requiredInvestments}`,
        },
        {
          key: {
            ru: `Выручка за ${prevYear} год`,
            en: `Actual revenues in ${prevYear}`,
          },
          value: getProfitValue(exhibitor.previousYearProfit),
        },
        {
          key: {
            ru: `Планы по выручке на ${year} год`,
            en: `Estimated revenues in ${year}`,
          },
          value: getProfitValue(exhibitor.plannedProfitThisYear),
        },
        {
          key: {
            ru: "Конкурентные преимущества продукта",
            en: "Competitive advantages of the product",
          },
          value: this.$fmt.localize(exhibitor.competitiveAdvantages),
          text: true,
        },
        {
          key: {
            ru: "Особенности «фишка» продукта/проекта",
            en: "Features which make product/project distinguished",
          },
          value: this.$fmt.localize(exhibitor.projectFeatures),
          text: true,
        },
      ]
    },

    country () {
      const country = this.exhibitor.companyCountry
      return this.$t("geo.countries")[country] || country
    },
    region () {
      if (this.exhibitor.companyCountry !== "RU") return ""
      const region = this.exhibitor.companyRegion
      return this.$t("geo.regions.ru")[region] || region
    },
    location () {
      return [this.country, this.region].filter(Boolean).join(", ")
    },

    visibleWebsite () {
      return simpleUrl(this.exhibitor.companyWebsite)
    },
  },

  async mounted () {
    await this.fetchFavoriteExhibitors()
  },

  methods: {
    ...mapActions("user", ["fetchFavoriteExhibitors", "setFavoriteExhibitor"]),

    getProfitValue (item) {
      return `${Number(item.amount).toLocaleString()} ${item.currency}`
    },

    async toggleLike () {
      if (!this.$auth.loggedIn)
        return this.$router.push(this.localePath("/login"))

      await this.setFavoriteExhibitor({
        id: this.exhibitor.id, isFavorite: !this.isFavorite,
      })

      const [res, err] = await this.$api.exhibition.getApp(this.exhibitor.id)
      if (err) {
        console.error(err)
        return
      }
      this.exhibitor = res
    },
  },
}
